const validate = values => {
	const errors = {}
	if (!values.general_warranty_type) {
		errors.general_warranty_type = 'Este Campo es Obligatorio'
	}
	return errors
}
	
export default validate
  


/** WEBPACK FOOTER **
 ** ./src/components/Validations/submitValidationsGeneralWarrantyForm.js
 **/